import React, { useEffect, useRef, useState } from "react";
import esriConfig from "@arcgis/core/config";
import Map from "@arcgis/core/Map";
import * as geometry from "@arcgis/core/geometry";
import MapView from "@arcgis/core/views/MapView";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import PictureMarkerSymbol from "@arcgis/core/symbols/PictureMarkerSymbol";
import Graphic from "@arcgis/core/Graphic";
import Point from "@arcgis/core/geometry/Point";
import icon from "style/images/svg/car-bridge.svg"
import footicon from 'style/images/svg/walk-bridge.svg'
import Fullscreen from "@arcgis/core/widgets/Fullscreen";
import FullscreenVM from "@arcgis/core/widgets/Fullscreen/FullscreenViewModel";


esriConfig.request.proxyUrl = "../proxy/proxy.ashx";
// const GraphicLayer_carBridge = new GraphicsLayer({ id: "carBridge"});
// mymap.add(GraphicLayer_carBridge)



const MapSidebar = ({ bridgeData, selectedBridge,foot}) => {
  const elementRef = useRef(null);
  const mymap = new Map({
    basemap: "osm",
  })
  const view = new MapView({
    map: mymap,
    center: [121.30115, 24.99658], // Longitude, latitude
    zoom: 14, // Zoom level
  })


  var fullscreenViewModel = new FullscreenVM({
    view: view,
    container: document.createElement("div")
  })
  var fullscreen = new Fullscreen({
    viewModel: fullscreenViewModel,
  });

  var symbol;
  if (foot){
    symbol = new PictureMarkerSymbol({ url: footicon, width: 25, height: 29 })
    symbol.set(0, 25)
  }else{
    symbol = new PictureMarkerSymbol({ url: icon, width: 25, height: 29 })
    symbol.set(0, 25)
  }

  let graphics = []
  bridgeData.forEach(item => {
    var point = new Point([Math.round(item.x * 100000000) / 100000000, Math.round(item.y * 100000000) / 100000000])
    point.spatialReference = new geometry.SpatialReference({ wkid: 4326 })
    var graph = new Graphic(point, symbol, item)
    graphics.push(graph)
    // GraphicLayer_carBridge.add(graph)
  });
  var FeatureLayer_carBridge = new FeatureLayer({
    title: "carBridge",
    source: graphics,
    objectIdField: "id",
    fields: [
      {
        name: "bridge_Name",
        type: "string"
      },
      {
        name: "bridge_Id",
        type: "string"
      },
      {
        name: "adm",
        type: "string"
      },
      {
        name: "section",
        type: "string"
      },
      {
        name: "county",
        type: "string"
      },
      {
        name: "town",
        type: "string"
      },
      {
        name: "road_Lv",
        type: "string"
      },
      {
        name: "route",
        type: "string"
      },
      {
        name: "structure",
        type: "string"
      }],
    popupTemplate: {
      title: "{bridge_Name}",
      content:
        `
      <table class="table">
      <tbody>
        <tr>
          <td>橋梁編號：</td>
          <td>{bridge_Id}</td>
        </tr>
        <tr>
          <td>管理機關：</td>
          <td>{adm}</td>
        </tr>
        <tr>
          <td>轄下機關：</td>
          <td>{section}</td>
        </tr>
        <tr>
        <td>所在縣市：</td>
        <td>{county}</td>
        </tr>
        <tr>
        <td>所在區鄉：</td>
        <td>{town}</td>
        </tr>
        <tr>
        <td>道路等級：</td>
        <td>{road_Lv}</td>
        </tr>
        <tr>
        <td>路線：</td>
        <td>{route}</td>
        </tr>
        <tr>
        <td>結構形式：</td>
        <td>{structure}</td>
        </tr>
      </tbody>
      </table>
      `,
    },
    renderer: {
      type: "simple",
      symbol: symbol
    }
  })
  mymap.add(FeatureLayer_carBridge);
  view.ui.add(fullscreen, "top-right");
  var screenPoint;
  view.on("click", function (event) {
    screenPoint = {
      x: event.x,
      y: event.y
    };
    // Search for graphics at the clicked location
    view.hitTest(screenPoint).then(function (response) {
      if (response.results.length) {
        var graphic = response.results.filter(function (result) {
          // check if the graphic belongs to the layer of interest
            console.log(result)
          return result.graphic.layer === FeatureLayer_carBridge;
        })[0].graphic
        // do something with the result graphic\     
        console.log(graphic)
        view.goTo({
          target: graphic.geometry,
        })
      }
    })
  })
  view.on("pointer-move", function (event) {
    screenPoint = {
      x: event.x,
      y: event.y
    };

    // Search for graphics at the clicked location
    view.hitTest(screenPoint).then(function (response) {
      if (response.results.length) {
        var graphic = response.results.filter(function (result) {
          // check if the graphic belongs to the layer of interest

          return result.graphic.layer === FeatureLayer_carBridge;
        })[0].graphic
        // do something with the result graphic
        document.getElementById("viewDiv").style.cursor = "pointer"
      }
      else {
        document.getElementById("viewDiv").style.cursor = "default"
      }
    })
  })
  const init = (container) => {
    // GraphicLayer_carBridge.graphics.removeAll()
    view.container = container;
    view.when(
    )
      .then(_ => {
        console.log("Map and view are ready")
      })
      .catch(err => {
        console.log(err)
      })
    return () => {
      view.container = null
    }
  }
  const goto = (container) => {
    if (Object.keys(selectedBridge).length>0){
      let graphic = graphics.filter(item=>item.attributes==selectedBridge)[0];
      // var graphic = response.results.filter(function (result) {
      //   // check if the graphic belongs to the layer of interest

      //   return result.graphic.layer === FeatureLayer_carBridge;
      // })[0].graphic
view.container = container;
    view.when(
      view.goTo({
        target: graphic.geometry,
      }),
      view.popup.open({
        location:graphic.geometry,
        features:[graphic]
      })
    )
      .then(_ => {
        console.log("Map and view are ready")
      })
      .catch(err => {
        console.log(err)
      })
    return () => {
      view.container = null
    }

    }
  }
  useEffect(() => {
    if (bridgeData.length > 0) {
      init(elementRef.current)
    }
  }, [bridgeData])
  useEffect(() =>{
    goto(elementRef.current);
  },[selectedBridge])
  return (

    <div className="MapSidebar" id="viewDiv" ref={elementRef}>
    </div>
  )
}

export default MapSidebar;